import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { WishlistStatusPillComponent } from '../wishlist-status-pill/wishlist-status-pill.component';
import type { WishlistStatusPillTone } from '../../types/wishlist-status-pill-tone.type';

@Component({
  selector: 'wishlist-visibility-indicator',
  imports: [WishlistStatusPillComponent],
  templateUrl: './wishlist-visibility-indicator.component.html',
  styleUrl: './wishlist-visibility-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistVisibilityIndicatorComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly iconLabel: InputSignal<string> = input<string>('L');
  public readonly tone: InputSignal<WishlistStatusPillTone> = input<WishlistStatusPillTone>('neutral');
  public readonly compact: InputSignal<boolean> = input<boolean>(false);
}
